
import Vue, { PropOptions } from 'vue';
import Ad, { AdClickPeriod } from '@/store/modules/ads/ad';
import { formatNumber } from '@/i18n';
import AdClickUsersModal from '@/components/layout/ad-click-users-modal.vue';

export default Vue.extend({
  name: 'AdClickStats',
  props: {
    ad: { type: Ad, required: true },
    summary: { type: Boolean, default: false },
    period: { type: Object, default: null } as PropOptions<AdClickPeriod | null>,
  },
  computed: {
    clickCount(): number | null {
      return this.period ? this.ad.periodClickCount : this.ad.clickCount;
    },
    trackingMessage(): string {
      if (this.clickCount === null) {
        return this.period ? this.$t('Tracking data unavailable for this period.') : this.$t('No tracking data available.');
      }
      return '';
    },
  },
  methods: {
    formatNumber,
    showDetails() {
      this.$modal.show(AdClickUsersModal, {
        ad: this.ad,
        period: this.period,
        trackingMessage: this.trackingMessage,
      }, { name: 'ad-click-users' });
    },
  },
});
